import { Product } from '@/types/product';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FavoritesStore {
  favorites: Product[];
  addFavorite: (product: Product) => void;
  removeFavorite: (productId: string) => void;
  isFavorite: (productId: string) => boolean;
  clearFavorites: () => void;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      favorites: [],
      addFavorite: product =>
        set(state => {
          const exists = state.favorites.some(fav => fav.id === product.id);
          if (exists) return state;
          return {
            favorites: [...state.favorites, product],
          };
        }),
      removeFavorite: productId =>
        set(state => ({
          favorites: state.favorites.filter(item => item.id !== productId),
        })),
      isFavorite: productId =>
        get().favorites.some(item => item.id === productId),
      clearFavorites: () => set({ favorites: [] }),
    }),
    {
      name: 'favorites-storage',
      storage: {
        getItem: name => {
          const str = localStorage.getItem(name);
          return str ? JSON.parse(str) : null;
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: name => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);
